import styled from 'styled-components';

export const QuestionIconWrapper = styled.div`
  position: relative;
  display: flex;
  flex-shrink: 0;
  align-items: center;
  color: var(--color-text-muted);

  .question-content {
    display: none;
  }

  :hover .question-content {
    display: block;
  }
`;
